import UAParser from 'ua-parser-js';

export const getOS = ({ override } = {}) => {
  if (typeof override === 'string') {
    // eslint-disable-next-line default-case
    switch (override.toLowerCase()) {
      case 'ios':
        return 'iOS';
      case 'windows':
        return 'Windows';
      case 'android':
        return 'Android';
    }
  }

  const name = new UAParser().getOS().name;

  if (name === 'iOS') {
    return 'iOS';
  }
  return name.startsWith('Windows') ? 'Windows' : 'Android';
};

export const getOSVersion = () => new UAParser().getOS().version;

export const isMobile = () => {
  const name = new UAParser().getOS().name.toLowerCase();

  if (name.includes('ios') || name.includes('android')) {
    return true;
  }

  return false;
};

export const getFeatureFlagOverrides = (options = {}) => {
  const { enable = [], disable = [], valid = {} } = options;
  const features = {};

  for (const featureName of enable) {
    if (valid[featureName]) {
      features[featureName] = true;
    }
  }

  for (const featureName of disable) {
    if (valid[featureName]) {
      features[featureName] = false;
    }
  }

  return features;
};

export const strToArray = (str, def = []) =>
  typeof str === 'string' ? str.split(',') : def;
